import {Component, Input} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../../../core";

@Component({
  selector: 'app-temporary-otp-modal',
  templateUrl: './temporary-otp-modal.component.html',
  styleUrls: ['./temporary-otp-modal.component.css']
})
export class TemporaryOTPModalComponent {
  @Input() props?:{
    request: any,
    returnUrl: string
    onClose: () => void
  }

  otp = '';

  working = false;
  error = '';

  constructor(
    private auth: AuthenticationService,
    private modalRef: BsModalRef,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }


  getLandingPage(response: any) {
    let roles = this.auth.getGrantedAuthority(response);
    let landing = "/dashboard";
    if (roles.includes("CAC_CRP_DATA_ENTRY_OFFICER")) {
      landing = "/dashboard";
    } else {
      landing = "/company-registration/company-list";
    }
    return landing;
  }

  proceed(){
    if (!this.otp?.length || (this.otp?.length < 6)) {
      this.error = 'Please enter a valid OTP';
      return;
    }

    this.working = true;

    this.auth.verifyOtp({
      authType: 'USERNAME',
      value: this.props?.request.username,
      code: this.otp,
    }).subscribe({
      next: (e) => {
        const landingPage = this.getLandingPage(e);
        const returnUrl = this.route.snapshot.queryParams?.redirect || landingPage
        this.router.navigateByUrl(returnUrl);
        this.modalRef.hide();
      },
      error: (err) => {
        this.error = err?.error?.message || 'Invalid or expired token!'
        this.working = false;
      }
    })

  }

  onClose(){
    this.props?.onClose();
    this.modalRef.hide();
  }
}
